import { FormInput, mixins, styled } from '@bob/library'

export const Wrapper = styled.div`
  ${mixins.padding(20, 40)};
`

export const Title = styled.h2`
  ${mixins.typography.headlineLarge}
`

export const InputWrapper = styled.div`
  display: flex;

  & > label {
    width: 100%;
    ${mixins.margin.right(5)}
  }

  & > button {
    ${mixins.margin.left(20)}
  }
`

export const Input = styled(FormInput)`
  height: 100%;
`

export const Info = styled.p`
  margin-bottom: 20px;
`

export const SocialMediaWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 20px 0;

  & > *:not(:first-child) {
    ${mixins.cta.hyperlink('blue')}
    ${mixins.margin.left(30)}
  }
`
export const Copy = styled.button`
  ${mixins.cta.primary('black')}
`
export const ShareLink = styled.a`
  ${mixins.cta.hyperlink('black')}
`
